import React, { useState } from 'react';
import Button from '../../atoms/button/Button';
import FilterButton from '../../atoms/FilterButton/FilterButton';
import FilterModal from '../modal/FilterModal/FilterModal';

const Filterbar = ({ onSubmit, onCancel, children, applyDisabled, clearDisabled, onlyModal, className, hideApply, hideClear, isLoading = false }) => {
  const [showMobileModal, setShowMobileModal] = useState(false);

  const handleOpenModal = () => {
    setShowMobileModal(true);
  };

  const handleSubmit = (data) => {
    onSubmit(data);
    handleClose();
  };

  const handleCancel = () => {
    onCancel();
    handleClose();
  };

  const handleClose = () => {
    setShowMobileModal(false);
  };

  return (
    <>
      {!onlyModal && (
        <form
          data-testid='filter-bar'
          onSubmit={onSubmit}
          className={`hidden flex-wrap items-end gap-4 md:flex ${onlyModal && '!hidden'} ${className ? className : ''}`}>
          {children}

          {!hideApply && (
            <Button
              title='Apply'
              type='submit'
              disabled={applyDisabled}
              testId='filter-bar-apply'
            />
          )}

          {!hideClear && (
            <Button
              title='Clear'
              type='button'
              variant='ghost'
              onClickHandler={handleCancel}
              disabled={clearDisabled}
              testId='filter-bar-clear'
            />
          )}
        </form>
      )}

      <div className={`flex items-center justify-end gap-4 md:hidden ${onlyModal && '!flex'}`}>
        <FilterButton
          isLoading={isLoading}
          onClick={handleOpenModal}
        />

        {showMobileModal && (
          <FilterModal
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            onClose={handleClose}
            submitButtonDisabled={applyDisabled}
            openOnLoad>
            {children}
          </FilterModal>
        )}
      </div>
    </>
  );
};

export default Filterbar;
